<template>
	<div class="cruBox" :style="{ height: !crumFlag ? '10px' : '' }">
		<span @click="fhFn1" v-if="crumFlag && bTxt">{{ bTxt }}</span>
		<div :style="{ background: back ? back : '' }" v-if="crumFlag && txt.length > 0">
			<div class="crumBox" :style="{ height: height ? height : '', width: width ? width : '' }">
				<div v-if="type == 1" @click="fhFn" class="crumBtn">
					<img src="@/assets/img/fh.svg" alt="" />
					<span v-for="(item, index) in txt" :key="index">{{ item }}{{ index == txt.length - 1 ? '' : '/' }}</span>
				</div>
				<template v-if="type == 2">
					<div v-for="(item, index) in txt" class="btns" :key="index" @click="fhsFn(item, index)" :style="{ color: index == txt.length - 1 ? '#1D7B3A' : '' }">
						<p :title="item">{{ item }}</p>
						<div>{{ index == txt.length - 1 ? '' : '>' }}</div>
					</div>
				</template>
				<template v-if="type == 3">
					<div v-for="(item, index) in txt" class="btns" :key="index" @click="fhsFn(item, index)" :style="{ color: index == txt.length - 1 ? '#1D7B3A' : '' }">
						<p :title="item">{{ item }}</p>
						<div>{{ index == txt.length - 1 ? '' : '>' }}</div>
					</div>
				</template>
			</div>
		</div>
		<!-- <div class="cruH" v-else>

    </div> -->
	</div>
</template>

<script>
export default {
	name: 'crumbsA',
	data() {
		return {};
	},
	props: {
		txt: {
			type: Array,
			default: () => []
		},
		ljList: {
			type: Array,
			default: () => []
		},
		bTxt: {
			type: String,
			default: ''
		},
		crumFlag: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: '1'
		},
		hdType: {
			type: String,
			default: ''
		},
		height: {
			type: String,
			default: ''
		},
		width: {
			type: String,
			default: ''
		},
		back: {
			type: String,
			default: ''
		}
	},
	methods: {
		fhFn1() {
			if (this.hdType) {
				this.$emit('lookBtn');
				return;
			}
			if (this.ljList.length) {
				this.$emit('hdBtn');
			} else {
				this.$router.back();
			}
		},
		fhFn(index) {
			if (index == this.txt.length - 1) return;
			if (index == 0 && this.txt.length > 2) {
				this.$router.go(-2);
				return;
			}
			this.$router.back();
		},
		fhsFn(name, index) {
			if (name == '首页') {
				this.$router.push({
					path: 'home'
				});
			} else if (name == '每期课件') {
				this.$router.push({
					path: 'kejianTj'
				});
			} else if (name == '歌曲列表') {
				this.$router.push({
					path: 'zlmwHome',
					query: {
						tabType: 1
					}
				});
			} else if (name == '演讲列表') {
				this.$router.push({
					path: 'zlmwHome',
					query: {
						tabType: 2
					}
				});
			} else if (name == '美文列表') {
				this.$router.push({
					path: 'zlmwHome',
					query: {
						tabType: 3
					}
				});
			} else if (name == '电影列表') {
				this.$router.push({
					path: 'dianyingHome'
				});
			} else if (name == '同步课件') {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						yzType: '2',
						classType: 1,
						tabFtxt: '同步课件'
					}
				});
			} else if (name == '最新试卷') {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						yzType: '2',
						classType: 2,
						tabFtxt: '最新试卷'
					}
				});
			} else if (name == '双语新闻') {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						yzType: '2',
						classType: 8,
						treFlag: false,
						tabFtxt: '双语新闻'
					}
				});
			} else if (name == '优质课件') {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						yzType: '2',
						classType: 3,
						tabFtxt: '优质课件'
					}
				});
			} else if (name == '双语节目') {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						yzType: '2',
						classType: 5,
						treFlag: false,
						tabFtxt: '双语节目'
					}
				});
			} else if (name == '英文小说') {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						yzType: '2',
						classType: 6,
						treFlag: false,
						tabFtxt: '英文小说'
					}
				});
			} else if (name == '荐阅外刊') {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						yzType: '2',
						classType: 4,
						treFlag: false,
						tabFtxt: '荐阅外刊'
					}
				});
			} else if (name == '优质课') {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						yzType: '2',
						classType: 7,
						treFlag: false,
						tabFtxt: '优质课'
					}
				});
			} else if (name == '高考真题') {
				this.$router.push({
					path: 'zystHome',
					query: {
						txt: '高考真题'
					}
				});
			} else if (name == '每日一听') {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						type: 2,
						classType: 9,
						tabFtxt: '每日一听'
					}
				});
			} else if (name == '常用工具') {
				this.$router.push({
					path: 'changyGj',
					query: {
						tabFtxt: '常用工具'
					}
				});
			} else if (name == '共享互助') {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						type: 2,
						classType: 10,
						tabFtxt: '共享互助'
					}
				});
			} else if (name == '扩展阅读') {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						yzType: 2,
						classType: 11,
						treFlag: false,
						tabFtxt: '扩展阅读'
					}
				});
			} else if (name == '我的试卷') {
				this.$router.push({
					path: 'mySj'
				});
			} else if (name == '听力课本') {
				this.$router.push({
					path: 'tingliHome'
				});
			} else {
				if (index == this.txt.length - 1) {
				} else {
					this.$router.back();
				}
			}
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.cruH {
	height: 10px;
}
.btns {
	display: flex;
	cursor: pointer;

	p {
		max-width: 400px;
		overflow: hidden; /* 确保超出容器的内容被裁剪 */
		white-space: nowrap; /* 确保文本在一行内显示 */
		text-overflow: ellipsis; /* 超出部分显示省略号 */
	}
	div {
		margin: 0 6px;
	}
}
.cruBox {
	display: flex;
	width: 1200px;
	height: 53px;
	margin: 0 auto;
	align-items: center;
	span {
		font-size: 14px;
		color: #1d7b3a;
		margin-right: 10px;
		cursor: pointer;
	}
}
.crumBtn {
	display: flex;
	align-items: center;
	span {
		line-height: 1;
		margin-top: -2px;
	}
}
.crumBox {
	display: flex;
	align-items: center;
	color: #5f5f5f;
	font-size: 14px;
	img {
		cursor: pointer;
		width: 8px;
		height: 15px;
		margin-right: 8px;
	}
	span {
		cursor: pointer;
	}
}
</style>
